// extracted by mini-css-extract-plugin
export default {"wrapper":"SideBarPlant_wrapper__1j8Ya"};